import { configure } from "axios-hooks";
import LRU from "lru-cache";
import Axios from "axios";

const axios = Axios.create({
    baseURL: "https://sii-api.ibmetro.gob.bo/v1/",
    //baseURL: "http://192.168.2.30:10174/prueba-siibf/api/web/v1/",
    //baseURL: "http://192.168.2.39:10174/api/web/v1/",
});
const cache = new LRU({ max: 3 });
const init = () => { };

axios.interceptors.request.use((req) => {
    if (localStorage["auth"]) {
        const auth = JSON.parse(localStorage["auth"]);
        if (auth.token) {
            req.headers.Authorization = `Bearer ${auth.token}`;
        }
    }
    return req;
});

axios.interceptors.response.use((res) => {
    if (res.status === 401) {
        console.error("No esta autorizado");
    }
    return res;
});
configure({ axios, cache });

export default init;
